module.exports = __webpack_public_path__ + "static/media/R.9ff8c136.png";